import { useState } from 'react';
import { Layout as AntLayout, theme } from 'antd';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { DynamicSidebar } from './DynamicSidebar';
import { TrialBanner } from './TrialBanner';
import { DemoBanner } from './DemoBanner';

const isDemo = import.meta.env.VITE_DEMO_MODE === 'true';
import type { PanelConfig } from '../types/panelConfig';

const { Header, Sider, Content } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
  config: PanelConfig;
}

export function Layout({ children, config }: LayoutProps) {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <AntLayout style={{ minHeight: '100vh' }}>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: collapsed ? 14 : 16,
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {collapsed ? 'RG' : config.firmName}
        </div>
        <DynamicSidebar reports={config.reports} />
      </Sider>
      <AntLayout>
        {isDemo && <DemoBanner />}
        {config.trialInfo && (
          <TrialBanner
            daysRemaining={config.trialInfo.daysRemaining}
            expiresAt={config.trialInfo.expiresAt}
          />
        )}
        <Header
          style={{
            padding: 0,
            background: colorBgContainer,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {collapsed ? (
            <MenuUnfoldOutlined
              style={{ fontSize: 18, padding: '0 24px', cursor: 'pointer' }}
              onClick={() => setCollapsed(false)}
            />
          ) : (
            <MenuFoldOutlined
              style={{ fontSize: 18, padding: '0 24px', cursor: 'pointer' }}
              onClick={() => setCollapsed(true)}
            />
          )}
        </Header>
        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            minHeight: 280,
          }}
        >
          {children}
        </Content>
      </AntLayout>
    </AntLayout>
  );
}
